import { render } from "./modalDetails.vue?vue&type=template&id=68b1e250&scoped=true"
import script from "./modalDetails.vue?vue&type=script&lang=js"
export * from "./modalDetails.vue?vue&type=script&lang=js"

import "./modalDetails.vue?vue&type=style&index=0&id=68b1e250&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b1e250"]])

export default __exports__